import { FunctionComponent as F } from "react";
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Box from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { RowGroup } from "./CostBreakdownRowGroup";
import CostBreakdownText from "./CostBreakdownText";
import Stack from '@mui/material/Stack';


interface IProps
{
  row: RowGroup;
  key: string | number,
  open?: boolean,
  toggleOpen?: () => void,
  backgroundColor?: string,
  fontSize?: number,
  bold?: boolean,
}


const CostBreakdownRow: F<IProps> = (props: IProps) =>
{
  const row = props.row;

  return (
    <TableRow style={{ backgroundColor: props.backgroundColor || 'transparent' }}>

      <TableCell key={'item'} id='Item' style={{ flexGrow: 0.5 }}>
        <Stack direction={'row'} sx={{ display: 'flex', alignItems: 'center' }}>
          <CostBreakdownText
            text={row.item}
            fontSize={props.fontSize}
            bold={props.bold}
            tooltip={row.tooltip}/>
          {row.itemSymbol || <></>}
        </Stack>
      </TableCell>

      <TableCell id='Value' style={{ flexGrow: 0.5 }}>
        <Stack direction={'row'} sx={{ display: 'flex', alignItems: 'center' }}>
          <Box style={{ flexGrow: 1 }}/>
          {row.valueSymbol || <></>}
          <CostBreakdownText
            text={row.value}
            fontSize={props.fontSize}
            bold={props.bold}
            textColor={row.valueColor}
            tooltip={row.tooltip}/>
        </Stack>
      </TableCell>

      <TableCell>
        {(row.rows && props.toggleOpen) ?
          <Box onClick={props.toggleOpen}>
            {props.open ?
              <KeyboardArrowDownIcon sx={{ mb: -1, mt: -1 }}/> :
              <KeyboardArrowUpIcon sx={{ mb: -1, mt: -1 }}/>}
          </Box> :
          <Box/>}
      </TableCell>

    </TableRow>);
};

export default CostBreakdownRow;
